module.exports = __webpack_public_path__ + "static/media/PATS_4-634w.ab0661fa.webp";